import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-xmark',
    templateUrl: './xmark.component.svg',
    styleUrls: ['./xmark.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XmarkComponent {}
